import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrFinalCausalityProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import HighlightIcon from '@mui/icons-material/Highlight';
import { usePqrFinalCausality } from './hook';

export const PqrFinalCausality = ({
    finalCausality,
}: PqrFinalCausalityProps) => {
    const { formik } = usePqrFinalCausality(finalCausality);
    return (
        <Accordion
            title="AMPARO"
            icon={<HighlightIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Amparo"
                        name="protection"
                        size="small"
                        value={formik.values.protection}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
